/**
 * Lead stage progression (tv-2na.8.12). A payment that secures a booking makes
 * the customer BOOKED; nothing else advanced lead_stage, so a paid customer sat
 * at 'deposit-pending' / 'qualifying' on the record and in the funnel counts.
 *
 * FORWARD-ONLY along the funnel new -> qualifying -> deposit-pending -> booked ->
 * completed: an advance never moves a customer backwards (a 'completed' returning
 * client stays 'completed'). A 'lapsed' / 'dormant' customer who pays is back in
 * the funnel, so they advance. 'do-not-contact' is a compliance flag, never
 * overwritten; an unknown stage is left alone.
 */
const FUNNEL_RANK: Readonly<Record<string, number>> = {
  lapsed: 0,
  dormant: 0,
  new: 0,
  qualifying: 1,
  'deposit-pending': 2,
  booked: 3,
  completed: 4,
};

export type AdvanceableLeadStage = 'booked';

/** The stage after a forward-only advance to `to` (the current stage when it would go backwards). */
export function advanceLeadStage(current: string, to: AdvanceableLeadStage): string {
  const from = FUNNEL_RANK[current];
  if (from === undefined) return current;
  return from < FUNNEL_RANK[to]! ? to : current;
}
